export default function ValueProposition() {
  return (
    <section
      id="how-we-support"
      style={{ scrollMarginTop: '80px', backgroundColor: '#ffffff' }}
      className="px-6 pt-20 pb-20 min-h-screen"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full mb-3 border border-gray-300" style={{ backgroundColor: 'rgba(0,0,0,0.05)' }}>
            <i className="ri-global-line text-gray-700 text-sm"></i>
            <span className="text-xs font-bold text-gray-700 uppercase tracking-wider">How We Support</span>
          </div>
          <h4>
            <a href="#how-we-support" className="text-xl md:text-2xl font-bold font-serif leading-tight block mb-2" style={{ color: '#1a2a3a' }}>
              BB Global Financial Administration
            </a>
          </h4>
        </div>

        <div>
          <h3 className="text-lg md:text-xl font-bold text-center mb-4 font-serif" style={{ color: '#b8860b' }}>
            BB By Your Side:
          </h3>

          <div className="grid md:grid-cols-2 gap-3">
            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/8061be9678f2994bb88ac154d092a8ed.jpg"
                  alt="Peak Period Support"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <span className="text-white text-base font-bold font-serif drop-shadow">Peak Period</span>
                </div>
              </div>
              <div className="px-4 py-3">
                <p className="text-xs text-gray-700 leading-relaxed">
                  We keep your financial processes running smoothly and without interruption during your most demanding periods.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20financial%20consultant%20guiding%20team%20members%20with%20structured%20documents%20and%20process%20manuals%2C%20clear%20instruction%20session%20in%20a%20bright%20modern%20office%2C%20whiteboard%20with%20process%20flow%2C%20clean%20minimal%20background%2C%20warm%20neutral%20tones%2C%20collaborative%20guidance%20atmosphere&width=600&height=350&seq=vp-instruction-002&orientation=landscape"
                  alt="Instruction & Guidance"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <span className="text-white text-base font-bold font-serif drop-shadow">Instruction &amp; Guidance</span>
                </div>
              </div>
              <div className="px-4 py-3">
                <p className="text-xs text-gray-700 leading-relaxed">
                  We prepare clear, structured process documents that guide your team and reduce operational errors.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=precise%20financial%20data%20analysis%20on%20screen%2C%20accountant%20reviewing%20accurate%20reports%20and%20balance%20sheets%2C%20reliable%20numbers%20and%20charts%2C%20clean%20desk%20with%20organized%20documents%2C%20professional%20office%20setting%2C%20trust%20and%20precision%20atmosphere%2C%20minimal%20white%20background&width=600&height=350&seq=vp-reliable-003&orientation=landscape"
                  alt="Accurate & Reliable Management"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <span className="text-white text-base font-bold font-serif drop-shadow">Accurate &amp; Reliable</span>
                </div>
              </div>
              <div className="px-4 py-3">
                <p className="text-xs text-gray-700 leading-relaxed">
                  We bring precision and structure to your financial processes, ensuring reliable data and smooth operations.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=continuous%20business%20operations%20concept%2C%20seamless%20workflow%20handover%20between%20colleagues%2C%20steady%20and%20uninterrupted%20financial%20process%2C%20calm%20professional%20office%20environment%2C%20stability%20and%20continuity%20visual%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20background%2C%20support%20and%20reliability%20atmosphere&width=600&height=350&seq=vp-continuity-004&orientation=landscape"
                  alt="Operational Continuity Support"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <span className="text-white text-base font-bold font-serif drop-shadow">Operational Continuity</span>
                </div>
              </div>
              <div className="px-4 py-3">
                <p className="text-xs text-gray-700 leading-relaxed">
                  We ensure your financial administration continues without disruption during leave periods or increased workloads.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
